const map = {
	"./Abu Dhabi 1.jpg": 3084,
	"./Al Mamzer Beach.jpg": 9803,
	"./Burj Khalifa.jpg": 5358,
	"./Dubai 2.jpg": 6376,
	"./Dubai Marina 1.jpg": 6011,
	"./Dubai Marina 3.jpg": 5689,
	"./Dubai.jpg": 3554,
	"./Kite Beach.jpg": 4629,
	"./La Mer Beach.jpg": 1153,
	"./Mosque.jpg": 907
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8847;